import React from "react";
import { Box, Typography, Button, Stack, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { MARKETING_EVENTS, trackMarketingEvent } from "../utils/demoTracking";

/**
 * Closing call to action, on every page except the contact page itself.
 *
 * Offers both routes deliberately. Sending everyone to the contact form assumes they have already
 * decided, and most visitors have not: the demo is the cheaper next step for them, and it is the one
 * that does the convincing. `flexGrow` is gone: as a flex child of <main> it was stretching to absorb
 * all remaining vertical space on short pages, which left the heading floating in the middle of an
 * empty screen.
 */
const CallToAction = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        textAlign: "center",
        backgroundColor: "background.paper",
        py: { xs: 5, md: 7 },
        px: 2,
      }}
    >
      <Container maxWidth="sm">
        <Typography
          variant="h4"
          component="h2"
          sx={{ fontWeight: "bold", mb: 1.5 }}
        >
          Ready to run your merit badge college?
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 3, lineHeight: 1.7 }}>
          Tell us about your event and we will set it up for you. Or try the
          sandbox first: it takes no signup and nothing in it is real.
        </Typography>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1.5}
          justifyContent="center"
        >
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => navigate("/contact")}
          >
            Get started
          </Button>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            onClick={() => {
              trackMarketingEvent(MARKETING_EVENTS.DEMO_CTA_CLICKED);
              navigate("/demo");
            }}
          >
            Explore the demo
          </Button>
        </Stack>
      </Container>
    </Box>
  );
};

export default CallToAction;
